<div class="card-container">
  <mat-card class="datex-card card"
            data-cy="card" 
            [ngStyle]="styles.style" 
            [ngClass]="styles.classes">
    <ng-container
                  *ngIf="initialized ">



      <mat-card-title-group class="card-header">
        <div class="card-title-container">
          <ng-content></ng-content>
          <mat-card-title data-cy="card-title" class="card-title " >{{headerTitle}}</mat-card-title>
        </div>

        <div class="card-icon-container">
            <i data-cy="card-icon" [class]="'card-icon icon ms-Icon ms-Icon--' + headerIcon + headerIconSize + headerIconColor + headerIconTransparency"></i>
              <div data-cy="card-icon-text" class="card-icon-text">{{headerIconText}}</div>
        </div>
      </mat-card-title-group>


      <mat-card-content data-cy="card-content" class="card-content" >
        <div [formGroup]="formGroupContent"
             class="formdata">
                <div data-cy="fieldset-formGroupContent-id-newGroup1"
                     *ngIf="!content.fieldsets.newGroup1.hidden"
                     class="fieldset-container">
                  <div class="fieldsetsContainer"
                       [ngClass]="{'collapsible': content.fieldsets.newGroup1.collapsible }">
                    <div *ngIf="!content.fieldsets.newGroup1.hideTitle"
                         data-cy="fieldset-title"
                         class="fieldsetsTitle"
                         (click)="content.fieldsets.newGroup1.toggle()">
                      <span class="fieldsetsTitle-text"></span>
                      <i data-cy="fieldset-toggle"
                         *ngIf="content.fieldsets.newGroup1.collapsible"
                         class="icon"
                         [ngClass]="{'icon-ic_fluent_chevron_down_20_filled': !content.fieldsets.newGroup1.expanded, 'icon-ic_fluent_chevron_up_20_filled': content.fieldsets.newGroup1.expanded }"></i>
                    </div>
                    <div data-cy="fieldset-group"
                         *ngIf="content.fieldsets.newGroup1.expanded"
                         class="fieldsetsGroup">
                      <div data-cy="field-id-comment_tag" *ngIf="!content.fields.comment_tag.hidden" 
                            class="field-container full {{content.fields.comment_tag.invalid ? 'invalid' : ''}}"
                            [ngStyle]="content.fields.comment_tag.styles.style"
                            [ngClass]="content.fields.comment_tag.styles.classes">
                        <div class="label-container"
                              title="{{content.fields.comment_tag.label}}{{content.fields.comment_tag.required ? ' (required)' : ''}}">
                          <label data-cy="field-label" class="datex-label"
                                  title="{{content.fields.comment_tag.label}}">{{content.fields.comment_tag.label}}<span *ngIf="content.fields.comment_tag.required"
                                  class="required-asterisk">*</span></label>
                        </div>
                        <div data-cy="text" class="datex-text"
                              [ngStyle]="content.fields.comment_tag.control.styles.style"
                              [ngClass]="content.fields.comment_tag.control.styles.classes">{{content.fields.comment_tag.control.text }}</div>
                        <ng-container *ngIf="content.fields.comment_tag.invalid">
                          <ng-container *ngFor="let error of content.fields.comment_tag.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-discussion" *ngIf="!content.fields.discussion.hidden" 
                            class="field-container full {{content.fields.discussion.invalid ? 'invalid' : ''}}"
                            [ngStyle]="content.fields.discussion.styles.style"
                            [ngClass]="content.fields.discussion.styles.classes">
                        <div class="label-container"
                              title="{{content.fields.discussion.label}}{{content.fields.discussion.required ? ' (required)' : ''}}">
                          <label data-cy="field-label" class="datex-label"
                                  title="{{content.fields.discussion.label}}">{{content.fields.discussion.label}}<span *ngIf="content.fields.discussion.required"
                                  class="required-asterisk">*</span></label>
                        </div>
                        <textarea cdkTextareaAutosize cdkAutosizeMinRows="3" cdkAutosizeMaxRows="5" data-cy="textBox-multi"formControlName="discussion"
                                matInput
                                autocomplete="off"
                                spellcheck="false"
                                class="datex-textbox {{content.fields.discussion.control.readOnly ? 'readonly ' : ''}}"
                                placeholder="{{content.fields.discussion.control.placeholder}}"
                                [ngStyle]="content.fields.discussion.control.styles.style"
                                [ngClass]="content.fields.discussion.control.styles.classes"> </textarea>
                        <ng-container *ngIf="content.fields.discussion.invalid">
                          <ng-container *ngFor="let error of content.fields.discussion.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>            </div>
                  </div>
                </div>
              </div>      </mat-card-content>

      <mat-card-actions data-cy="card-actions" class="card-actions">
        <div data-cy="tool-id-save" *ngIf="!actionbar.save.hidden" class="toolContainer">
        <button mat-button
                data-cy="button"
                class="datex-button"
                [disabled]="actionbar.save.control.readOnly"
                [ngStyle]="actionbar.save.control.styles.style"
                [ngClass]="actionbar.save.control.styles.classes"
                (click)="on_save($event)"
                >
          <div class="button-label">
            <ng-container *ngIf="actionbar.save.control.icon === 'datex-default-spinner'; else showIcon">
              <div class="button-icon">
                <i data-cy="button-icon" class="datex-default-spinner"></i>
              </div>
            </ng-container>
            <ng-template #showIcon>
              <div class="button-icon">
                <i data-cy="button-icon" class="icon {{actionbar.save.control.icon}}"></i>
              </div>
            </ng-template>
            <div data-cy="button-label" class="button-text">{{actionbar.save.control.label}}</div>
          </div>
        
        </button>
        </div>
        <div data-cy="tool-id-read" *ngIf="!actionbar.read.hidden" class="toolContainer">
        <button mat-button
                data-cy="button"
                class="datex-button"
                [disabled]="actionbar.read.control.readOnly"
                [ngStyle]="actionbar.read.control.styles.style"
                [ngClass]="actionbar.read.control.styles.classes"
                (click)="on_read($event)"
                >
          <div class="button-label">
            <ng-container *ngIf="actionbar.read.control.icon === 'datex-default-spinner'; else showIcon">
              <div class="button-icon">
                <i data-cy="button-icon" class="datex-default-spinner"></i>
              </div>
            </ng-container>
            <ng-template #showIcon>
              <div class="button-icon">
                <i data-cy="button-icon" class="icon {{actionbar.read.control.icon}}"></i>
              </div>
            </ng-template>
            <div data-cy="button-label" class="button-text">{{actionbar.read.control.label}}</div>
          </div>
        
        </button>
        </div>
        <div data-cy="tool-id-on_delete" *ngIf="!actionbar.on_delete.hidden" class="toolContainer">
        <button mat-button
                data-cy="button"
                class="datex-button"
                [disabled]="actionbar.on_delete.control.readOnly"
                [ngStyle]="actionbar.on_delete.control.styles.style"
                [ngClass]="actionbar.on_delete.control.styles.classes"
                (click)="on_delete($event)"
                >
          <div class="button-label">
            <ng-container *ngIf="actionbar.on_delete.control.icon === 'datex-default-spinner'; else showIcon">
              <div class="button-icon">
                <i data-cy="button-icon" class="datex-default-spinner"></i>
              </div>
            </ng-container>
            <ng-template #showIcon>
              <div class="button-icon">
                <i data-cy="button-icon" class="icon {{actionbar.on_delete.control.icon}}"></i>
              </div>
            </ng-template>
            <div data-cy="button-label" class="button-text">{{actionbar.on_delete.control.label}}</div>
          </div>
        
        </button>
        </div>
        <div data-cy="tool-id-cancel" *ngIf="!actionbar.cancel.hidden" class="toolContainer">
        <button mat-button
                data-cy="button"
                class="datex-button"
                [disabled]="actionbar.cancel.control.readOnly"
                [ngStyle]="actionbar.cancel.control.styles.style"
                [ngClass]="actionbar.cancel.control.styles.classes"
                (click)="on_cancel($event)"
                >
          <div class="button-label">
            <ng-container *ngIf="actionbar.cancel.control.icon === 'datex-default-spinner'; else showIcon">
              <div class="button-icon">
                <i data-cy="button-icon" class="datex-default-spinner"></i>
              </div>
            </ng-container>
            <ng-template #showIcon>
              <div class="button-icon">
                <i data-cy="button-icon" class="icon {{actionbar.cancel.control.icon}}"></i>
              </div>
            </ng-template>
            <div data-cy="button-label" class="button-text">{{actionbar.cancel.control.label}}</div>
          </div>
        
        </button>
        </div>
      </mat-card-actions>


    </ng-container>

  </mat-card>
  <div class="card-gripper"></div>
</div>